export default __webpack_public_path__ + "static/WPS-P2P_02-5c56f0f05ac69132784f19892b22edaa.webp";